import { Route, Routes, Navigate } from 'react-router-dom';
import { ROUTES } from './routes.ts';
import { RetiredOnFulfillmentV2Launch } from './RetiredOnFulfillmentV2Launch.tsx';
import HomePage from '../pages/home/page.tsx';
import MatchSKUPage from '../pages/competitor/match-sku/page.tsx';
import MatchStatusPage from '../pages/competitor/match-status/page.tsx';
import DpLeanPage, { DpMatchDetailPage } from '../pages/competitor/v2/DpLeanPage.tsx';
import LoginPage from '../pages/login/page.tsx';
import CallbackPage from '../pages/auth/CallbackPage.tsx';
import AgentRegistryPage from '../pages/agent-registry/page.tsx';
import OrdersPage from '../pages/oms/orders/page.tsx';
import { OrderDetailPage } from '../pages/oms/orders/[id]/page.tsx';
import AuditPage from '../pages/oms/orders/[id]/audit/page.tsx';
import FulfillmentStatusPage from '../pages/oms/fulfillment/page.tsx';
import Fulfillment2Page from '../pages/fulfillment/orders/page.tsx';
import Fulfillment2DetailPage from '../pages/fulfillment/orders/detail/page.tsx';
import FulfillmentClosingPage from '../pages/fulfillment/closing/page.tsx';
import FulfillmentViewOrdersPage from '../pages/fulfillment/viewOrders/page.tsx';
import FulfillmentArrivalSortPage from '../pages/fulfillment/arrivalSort/page.tsx';
import FulfillmentReadyToOutboundPage from '../pages/fulfillment/readyToOutbound/page.tsx';
import FulfillmentInventoryPage from '../pages/fulfillment/inventory/page.tsx';
import FulfillmentUnrecognizedScansPage from '../pages/fulfillment/unrecognizedScans/page.tsx';
import FulfillmentReturnsPage from '../pages/fulfillment/returns/page.tsx';
import FulfillmentStockMovePage from '../pages/fulfillment/stockMove/page.tsx';
import FulfillmentStockTakePage from '../pages/fulfillment/stockTake/page.tsx';
import FulfillmentInboundRequestsPage from '../pages/fulfillment/inboundRequests/page.tsx';
import FulfillmentInboundRequestDetailPage from '../pages/fulfillment/inboundRequests/detail/page.tsx';
import PackingInvoicePrintPage from '../pages/fulfillment/packingInvoice/page.tsx';
import FulfilmentPicManagementPage from '../pages/oms/pic-management/page.tsx';
import GigWorkersPage from '../pages/oms/gig-workers/page.tsx';
import Layout from '../components/layout/Layout.tsx';
import ProtectedRoute from '../components/auth/ProtectedRoute.tsx';
import UiSpikePage from '../pages/ui-spike/page.tsx';
import BrandOnboardingPage from '../pages/b2b/brand-onboarding/page.tsx';
import MarketingSection from '../marketing/MarketingSection.tsx';
import DeliveryTracePage from '../pages/oms/orders/[id]/trace/page.tsx';
import BannerUploadPage from '../pages/site-management/banner/upload/page.tsx';
import BannerListPage from '../pages/site-management/banner/list/page.tsx';
import TrendingVideoUploadPage from '../pages/site-management/trending-videos/upload/page.tsx';
import TrendingVideoListPage from '../pages/site-management/trending-videos/list/page.tsx';
import MatchingPage from '../pages/sourcing/matching/page.tsx';
import MatchedProductsPage from '../pages/sourcing/matched/page.tsx';
import MatchedProductDetailPage from '../pages/sourcing/matched/[cpProductId]/page.tsx';
import ImageEditorPage from '../pages/sourcing/matched/[cpProductId]/image-editor/page.tsx';
import MatchedGpiPage from '../pages/sourcing/matched-gpi/page.tsx';
import SSCPRematchingPage from '../pages/sourcing/ss-cp-rematching/page.tsx';
import CategoryMappingPage from '../pages/sourcing/category-mapping/page.tsx';
import ReviewPage from '../pages/review/page.tsx';
import SurveyListPage from '../pages/survey/page.tsx';
import SurveySettingsPage from '../pages/survey/[surveyId]/settings/page.tsx';
import SurveyQuizPage from '../pages/survey/[surveyId]/quiz/page.tsx';
import SurveyStatisticsPage from '../pages/survey/[surveyId]/statistics/page.tsx';
import SurveyAnswersPage from '../pages/survey/[surveyId]/answers/page.tsx';
import SiteCacheManagementPage from '../pages/site-management/cache/page.tsx';
import CampaignPage from '../pages/site-management/campaign/page.tsx';
import ShippingPage from '../pages/site-management/shipping/page.tsx';
import RuleEnginePage from '../pages/site-management/rule-engine/page.tsx';
import CronJobPage from '../pages/system/cron-jobs/page.tsx';
import RedirectConfigurationPage from '../pages/system/redirect-configuration/page.tsx';
import IngredientPage from '../pages/category/ingredient/page.tsx';
import ScrapeBatchPage from '../pages/sourcing/scrape-batch/page.tsx';
import CoupangFailuresPage from '../pages/sourcing/coupang-failures/page.tsx';
import WMSViewOrdersPage from '../pages/oms/wms/view-orders/page.tsx';
import WMSStockPage from '../pages/oms/wms/stock/page.tsx';
import ReadyToBeOutbondedPage from '../pages/oms/wms/stock/readyToBeOutbonded/page.tsx';
import ShippingFeePage from '../pages/oms/shipping-fee/page.tsx';
import CustomsNamePromptPage from '../pages/oms/customs-name-prompt/page.tsx';
import GigCartVerificationPromptPage from '@/pages/oms/gig-cart-verification-prompt/page';
import BundleRecipesPage from '@/pages/oms/bundle-recipes/page';
import ZplPrintPage from '@/pages/oms/zpl-print/page';
import LoyaltyPage from '../pages/customer/loyalty/page.tsx';
import TierManagementPage from '../pages/customer/loyalty/tier-management/page.tsx';
import PushNotificationPage from '../pages/customer/push-notification/page.tsx';
import SSEditorPage from '../pages/catalog/ss-editor/page.tsx';
import CMWorkflowPage from '../pages/catalog/cm-workflow/page.tsx';
import ProductGroupListPage from '../pages/catalog/product-groups/list/page.tsx';
import ProductGroupEditPage from '../pages/catalog/product-groups/edit/page.tsx';
import CsPlaygroundPage from '../pages/cs-playground/page.tsx';
import CsPromptEditorPage from '../pages/cs-prompt-editor/page.tsx';
import KnowledgeBasePage from '../pages/knowledge-base/page.tsx';
import ClaudeCodeOverviewPage from '../pages/claude-code/ClaudeCodeOverviewPage.tsx';
import ClaudeCodeEmployeeDetailPage from '../pages/claude-code/ClaudeCodeEmployeeDetailPage.tsx';
import ClaudeCodeSessionDetailPage from '../pages/claude-code/ClaudeCodeSessionDetailPage.tsx';
import AgentSkillProposalDetailPage from '../pages/claude-code/AgentSkillProposalDetailPage.tsx';
import AgentSkillProposalsPage from '../pages/claude-code/AgentSkillProposalsPage.tsx';
import AgentAssetEvolutionReviewQueuePage from '../pages/claude-code/AgentAssetEvolutionReviewQueuePage.tsx';
import AgentRoleAssetDetailPage from '../pages/claude-code/AgentRoleAssetDetailPage.tsx';
import AgentRoleAssetsByRolePage from '../pages/claude-code/AgentRoleAssetsByRolePage.tsx';
import AgentRoleAssetsPage from '../pages/claude-code/AgentRoleAssetsPage.tsx';
import AgentTelemetryTopListPage from '../pages/claude-code/AgentTelemetryTopListPage.tsx';
import CommandCenterPage from '../pages/command-center/CommandCenterPage.tsx';
import McpAccessPage from '../pages/mcp-access/McpAccessPage.tsx';
import McpPeoplePage from '../pages/mcp-access/McpPeoplePage.tsx';
import SecretsListPage from '../pages/secrets/SecretsListPage.tsx';
import SecretDetailPage from '../pages/secrets/SecretDetailPage.tsx';
import SecretRequestsPage from '../pages/secrets/SecretRequestsPage.tsx';
import RecommendationLabPage from '../pages/recommendation-lab/page.tsx';
import SkinAnalysisDemoPage from '../pages/skin-analysis-demo/page.tsx';

const Router = () => {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<LoginPage />} />
      <Route path={ROUTES.authCallback} element={<CallbackPage />} />

      {/* Protected routes */}
      <Route
        path={ROUTES.home}
        element={
          <ProtectedRoute>
            <Layout>
              <HomePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.marketing.wildcard}
        element={
          <ProtectedRoute>
            <Layout>
              <MarketingSection />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.uiSpike}
        element={
          <ProtectedRoute>
            <Layout>
              <UiSpikePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.competitor.matchSKU.default}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchSKUPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.competitor.matchStatus}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchStatusPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Competitor Matching V2 is intentionally public per approved REQ-AUTHREMOVE: reads are unauthenticated and
          writes are enforced by the Facade Origin guard. Staff login (Logto) will be added later. */}
      <Route
        path={ROUTES.competitor.v2}
        element={
          <Layout>
            <DpLeanPage />
          </Layout>
        }
      />
      <Route
        path={ROUTES.competitor.matchDetail.pattern}
        element={
          <Layout>
            <DpMatchDetailPage />
          </Layout>
        }
      />
      <Route
        path={ROUTES.ai.agentRegistry}
        element={
          <ProtectedRoute>
            <Layout>
              <AgentRegistryPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ai.skinMatchDemo}
        element={
          <ProtectedRoute>
            <Layout>
              <SkinAnalysisDemoPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ai.recommendationLab}
        element={
          <ProtectedRoute>
            <Layout>
              <RecommendationLabPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.csPlayground}
        element={
          <ProtectedRoute>
            <Layout>
              <CsPlaygroundPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.csPromptEditor}
        element={
          <ProtectedRoute>
            <Layout>
              <CsPromptEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.knowledgeBase}
        element={
          <ProtectedRoute>
            <Layout>
              <KnowledgeBasePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.orders}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={() => ROUTES.fulfillment.orders}>
                <OrdersPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.fulfillment}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={() => ROUTES.fulfillment.orders}>
                <FulfillmentStatusPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.orders}
        element={
          <ProtectedRoute>
            <Layout>
              <Fulfillment2Page />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.fulfillment.orders}/:orderId`}
        element={
          <ProtectedRoute>
            <Layout>
              <Fulfillment2DetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.viewOrders}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentViewOrdersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.arrivalSort}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentArrivalSortPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.inventory}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentInventoryPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.unrecognizedScans}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentUnrecognizedScansPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.returns}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentReturnsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.stockMove}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentStockMovePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.stockTake}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentStockTakePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Marketing & Samples moved into the Orders list (SSD-7448); old links land on its Add orders modal. */}
      <Route
        path={ROUTES.fulfillment.marketing}
        element={<Navigate to={ROUTES.fulfillment.ordersAddOrders} replace />}
      />
      <Route
        path={ROUTES.fulfillment.readyToOutbound}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentReadyToOutboundPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.inboundRequests}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentInboundRequestsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.fulfillment.inboundRequests}/:docId`}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentInboundRequestDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* No Layout: this route is paper. Sidebar and header must not reach the printer. */}
      <Route
        path={`${ROUTES.fulfillment.orders}/:orderId/packingInvoice`}
        element={
          <ProtectedRoute>
            <PackingInvoicePrintPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.fulfillment.closing}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfillmentClosingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.picManagement}
        element={
          <ProtectedRoute>
            <Layout>
              <FulfilmentPicManagementPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.gigWorkers}
        element={
          <ProtectedRoute>
            <Layout>
              <GigWorkersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.oms.orders}/:id/trace/:trackingNo`}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={({ id }) => ROUTES.fulfillment.orderDetail(id)}>
                <DeliveryTracePage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.oms.orders}/:id/audit`}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={({ id }) => ROUTES.fulfillment.orderDetail(id)}>
                <AuditPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.oms.orders}/:id`}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={({ id }) => ROUTES.fulfillment.orderDetail(id)}>
                <OrderDetailPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.wms.viewOrders}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={() => ROUTES.fulfillment.viewOrders}>
                <WMSViewOrdersPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.wms.stock}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={() => ROUTES.fulfillment.inventory}>
                <WMSStockPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.wms.readyToBeOutbonded}
        element={
          <ProtectedRoute>
            <Layout>
              <RetiredOnFulfillmentV2Launch to={() => ROUTES.fulfillment.readyToOutbound}>
                <ReadyToBeOutbondedPage />
              </RetiredOnFulfillmentV2Launch>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.shippingFee}
        element={
          <ProtectedRoute>
            <Layout>
              <ShippingFeePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.customsNamePrompt}
        element={
          <ProtectedRoute>
            <Layout>
              <CustomsNamePromptPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.gigCartVerificationPrompt}
        element={
          <ProtectedRoute>
            <Layout>
              <GigCartVerificationPromptPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.bundleRecipes}
        element={
          <ProtectedRoute>
            <Layout>
              <BundleRecipesPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.oms.zplPrint}
        element={
          <ProtectedRoute>
            <Layout>
              <ZplPrintPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.banner.upload}
        element={
          <ProtectedRoute>
            <Layout>
              <BannerUploadPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.banner.list}
        element={
          <ProtectedRoute>
            <Layout>
              <BannerListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.trendingVideo.upload}
        element={
          <ProtectedRoute>
            <Layout>
              <TrendingVideoUploadPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.trendingVideo.list}
        element={
          <ProtectedRoute>
            <Layout>
              <TrendingVideoListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.default}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/glowpickId/:glowpickId"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/brand/:brand"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/category/:category/subcategory/:subcategory"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matching/category/:category"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.matching}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/:cpProductId/:cpItemId/image-editor/:tab?"
        element={
          <ProtectedRoute>
            <Layout>
              <ImageEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/:cpProductId/:cpItemId"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.matched}
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/category/:category/subcategory/:subcategory"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/category/:category"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedProductsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sourcing/matched/gpi/:gpi"
        element={
          <ProtectedRoute>
            <Layout>
              <MatchedGpiPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.ssReMatching}
        element={
          <ProtectedRoute>
            <Layout>
              <SSCPRematchingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.categoryMapping}
        element={
          <ProtectedRoute>
            <Layout>
              <CategoryMappingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.review.default}
        element={
          <ProtectedRoute>
            <Layout>
              <ReviewPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.survey.default}
        element={
          <ProtectedRoute>
            <Layout>
              <SurveyListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/survey/:surveyId/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <SurveySettingsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/survey/:surveyId/quiz"
        element={
          <ProtectedRoute>
            <Layout>
              <SurveyQuizPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/survey/:surveyId/statistics"
        element={
          <ProtectedRoute>
            <Layout>
              <SurveyStatisticsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/survey/:surveyId/answers"
        element={
          <ProtectedRoute>
            <Layout>
              <SurveyAnswersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path={ROUTES.questionnaire.default} element={<Navigate to={ROUTES.survey.default} replace />} />
      <Route
        path={ROUTES.siteManagement.cache}
        element={
          <ProtectedRoute>
            <Layout>
              <SiteCacheManagementPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.siteManagement.campaigns}
        element={
          <ProtectedRoute>
            <Layout>
              <CampaignPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.siteManagement.shipping}
        element={
          <ProtectedRoute>
            <Layout>
              <ShippingPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.siteManagement.ruleEngine}
        element={
          <ProtectedRoute>
            <Layout>
              <RuleEnginePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.systemManagement.cronJobs}
        element={
          <ProtectedRoute>
            <Layout>
              <CronJobPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.systemManagement.redirectConfiguration}
        element={
          <ProtectedRoute>
            <Layout>
              <RedirectConfigurationPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.category.ingredient.default}
        element={
          <ProtectedRoute>
            <Layout>
              <IngredientPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.catalog.ssEditor}
        element={
          <ProtectedRoute>
            <Layout>
              <SSEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/ss-editor/sku/:sku"
        element={
          <ProtectedRoute>
            <Layout>
              <SSEditorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.scrapeBatch}
        element={
          <ProtectedRoute>
            <Layout>
              <ScrapeBatchPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.sourcing.coupangFailures}
        element={
          <ProtectedRoute>
            <Layout>
              <CoupangFailuresPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.catalog.cmWorkflow}
        element={
          <ProtectedRoute>
            <Layout>
              <CMWorkflowPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.catalog.productGroups.list}
        element={
          <ProtectedRoute>
            <Layout>
              <ProductGroupListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.catalog.productGroups.new}
        element={
          <ProtectedRoute>
            <Layout>
              <ProductGroupEditPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/product-groups/:groupId"
        element={
          <ProtectedRoute>
            <Layout>
              <ProductGroupEditPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.loyalty}
        element={
          <ProtectedRoute>
            <Layout>
              <LoyaltyPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.tierManagement}
        element={
          <ProtectedRoute>
            <Layout>
              <TierManagementPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.customer.pushNotification}
        element={
          <ProtectedRoute>
            <Layout>
              <PushNotificationPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.agentTelemetry.overview}
        element={
          <ProtectedRoute>
            <Layout>
              <ClaudeCodeOverviewPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.agentTelemetry.proposals}
        element={
          <ProtectedRoute>
            <Layout>
              <AgentSkillProposalsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai/agent-telemetry/proposals/:proposalId"
        element={
          <ProtectedRoute>
            <Layout>
              <AgentSkillProposalDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.agentTelemetry.roleAssets}
        element={
          <ProtectedRoute>
            <Layout>
              <AgentRoleAssetsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.agentTelemetry.sharedAssetHealth}
        element={
          <ProtectedRoute>
            <Layout>
              <AgentAssetEvolutionReviewQueuePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.agentTelemetry.assetEvolution}
        element={<Navigate to={ROUTES.agentTelemetry.sharedAssetHealth} replace />}
      />
      <Route
        path={ROUTES.agentTelemetry.roleAssetsByRole}
        element={
          <ProtectedRoute>
            <Layout>
              <AgentRoleAssetsByRolePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai/agent-telemetry/role-assets/:assetId"
        element={
          <ProtectedRoute>
            <Layout>
              <AgentRoleAssetDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai/agent-telemetry/top/:kind"
        element={
          <ProtectedRoute>
            <Layout>
              <AgentTelemetryTopListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai/agent-telemetry/employees/:employeeId"
        element={
          <ProtectedRoute>
            <Layout>
              <ClaudeCodeEmployeeDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai/agent-telemetry/sessions/:sessionId"
        element={
          <ProtectedRoute>
            <Layout>
              <ClaudeCodeSessionDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ai.commandCenter}
        element={
          <ProtectedRoute>
            <Layout>
              <CommandCenterPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROUTES.ai.commandCenter}/:cardId`}
        element={
          <ProtectedRoute>
            <Layout>
              <CommandCenterPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path={ROUTES.claudeCode.overview} element={<Navigate to={ROUTES.agentTelemetry.overview} replace />} />
      <Route
        path="/claude-code/employees/:employeeId"
        element={
          <ProtectedRoute>
            <Layout>
              <ClaudeCodeEmployeeDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/claude-code/sessions/:sessionId"
        element={
          <ProtectedRoute>
            <Layout>
              <ClaudeCodeSessionDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.mcpAccess.default}
        element={
          <ProtectedRoute>
            <Layout>
              <McpAccessPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.mcpAccess.people}
        element={
          <ProtectedRoute>
            <Layout>
              <McpPeoplePage />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route path={ROUTES.mcpAccess.members} element={<Navigate to={ROUTES.mcpAccess.peopleTab('roles')} replace />} />

      <Route
        path={ROUTES.secrets.list}
        element={
          <ProtectedRoute>
            <Layout>
              <SecretsListPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.secrets.requests}
        element={
          <ProtectedRoute>
            <Layout>
              <SecretRequestsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/secrets/*"
        element={
          <ProtectedRoute>
            <Layout>
              <SecretDetailPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.b2b.brandOnboarding}
        element={
          <ProtectedRoute>
            <Layout>
              <BrandOnboardingPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Redirect to home if route doesn't match */}
      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  );
};

export default Router;
